module.exports = __webpack_public_path__ + "static/img/596.4251d40.png";